<template>
  <sui-modal size="mini" v-model="visible" animation="drop" :closable="false">
    <sui-modal-header>
      Are you sure?
    </sui-modal-header>
    <sui-modal-content v-if="options.text || options.fields.length">
      <sui-form @submit.prevent="submit()">
        <sui-form-field v-if="options.text">
          <div v-html="options.text" />
        </sui-form-field>
        <sui-form-field v-for="field in options.fields" :key="field.label">
          <label>{{field.label}}</label>
          <sui-input v-model="field.value" :placeholder="field.placeholder" />
        </sui-form-field>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button color="green" @click="submit()">Yes</sui-button>
        <sui-button color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
  const defaultOptions = {
    text: null,
    fields: [],
    callback() {},
  }
  export default {
    name: 'ModalConfirm',
    data() {
      return {
        visible: false,
        options: defaultOptions,
      }
    },
    watch: {
      visible(visible) {
        if (visible) {
          setTimeout(() => {
            if (this.options.fields.length) {
              this.$el.querySelector('input').select()
            }
          }, 500)
        }
      }
    },
    methods: {
      open(options = {}) {
        this.visible = true
        this.options = {...defaultOptions, ...options}
      },
      close() {
        this.visible = false
        this.reset()
      },
      reset() {
        this.options = defaultOptions
      },
      submit() {
        const params = {}
        for (const field of this.options.fields) {
          params[field.name] = field.value
        }
        this.options.callback(params)
        this.close()
      },
      cancel() {
        this.close()
      },
    },
    created() {
      this.$modals.confirm = this
    },
  }
</script>
